export default{
  "Video Compressor": "Video Compressor",
  "HitPaw Online Video Compressor": "HitPaw Online Video Compressor",
  "Best video compressor tool to reduce video file size online without losing quality.": "Best video compressor tool to reduce video file size online without losing quality.",
  "Quality": "Quality",
  "Small Size": "Small Size ({{num}}%)",
  "High Quality": "High Quality ({{num}}%)",
  "Frame Rate": "Frame Rate",
  "Resolution": "Resolution",
  "Keep Resolution": "Keep Resolution",
  "Format": "Format",
  "Compress": "Compress",
  "Compressing": "Compressing",
  "Compress New": "Compress New",
  "xx% reduction in size!": "{{num}}% reduction in size!",
  "Compressed successfully, your file is now xxMB.": "Compressed successfully, your file is now <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>",
  "Compression Failed": "Compression Failed",
};